<template>
  <div class="sala">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="cita" v-b-tooltip.hover.left
      :title="($debug?'ID:' + horarioClinica.idAgendaEmpleado+'-' +tamanio +' - ':'') +
      horarioClinica.idDoctor + '-' + horarioClinica.nombreDoctor+ ' Especialidad: ' + horarioClinica.especialidad
      +' Sillón: ' + horarioClinica.sillon
      +' Rango: ' + $formatoFecha(horarioClinica.fechaInicio) + ' al ' +$formatoFecha(horarioClinica.fechaFin)
      +' Horario: ' + $formatoHora(horarioClinica.horaInicio) + ' a ' +$formatoHora(horarioClinica.horaFin)
      + (horarioClinica.idBloque != null ? ('\nN° Bloques: '+horarioClinica.numeroBloques+ '\nHoras Bloques: '+  horarioClinica.numeroBloques ): '')"
      v-if="horarioClinica !== undefined && (idEspecialidadFiltro==null || horarioClinica.idEspecialidad === idEspecialidadFiltro)"
      @click.prevent="consultarDetalle(horarioClinica)"
      :style="horarioClinica.idBloque != null ? ancho+color+tamanio + bloqueStyle + colorBloque + '!important; background-size: 16px 48px !important;' :  ancho+color+tamanio"
      @contextmenu.prevent="$refs.menu.open"
    >
    </div>

    <div class="cita bloqueado" v-b-tooltip.hover.left
         :title="($debug?'ID:' + horarioClinica1.idAgendaInactiva+'-' +tamanio1 +' - ':'') + 
         ' Especialidad: ' + horarioClinica1.especialidad + ' Sillón: ' + horarioClinica1.sillon + ' Horario:'
          +' Rango: ' + $formatoFecha(horarioClinica1.fechaInicio) + '-' +$formatoFecha(horarioClinica1.fechaFin)
          +' Horario: ' + $formatoHora(horarioClinica1.horaInicio) + '-' +$formatoHora(horarioClinica1.horaFin)
          + ' !!Bloqueado!!'"
         v-if="horarioClinica1 !== undefined && (idEspecialidadFiltro==null || horarioClinica1.idEspecialidad === idEspecialidadFiltro)"
         :style="ancho+color1+tamanio1"
         @contextmenu.prevent="$refs.menu1.open"
    >
    </div>

    <div :class="horarioClinicaUnico.idBloque != null ? 'cita bloque-especialista' : 'cita' " v-b-tooltip.hover.left
         :title="($debug?'ID:' + horarioClinicaUnico.idAgendaEmpleado+'-' +tamanio2 +' - ':'') +
      horarioClinicaUnico.nombreDoctor+ ' Especialidad: ' + horarioClinicaUnico.especialidad + ' Sillón: ' + horarioClinicaUnico.sillon
      +' Rango: ' + $formatoFecha(horarioClinicaUnico.fechaInicio) + ' al ' +$formatoFecha(horarioClinicaUnico.fechaFin)
      +' Horario: ' + $formatoHora(horarioClinicaUnico.horaInicio) + ' a ' +$formatoHora(horarioClinicaUnico.horaFin)+
      '\nN° Bloques: '+horarioClinicaUnico.numeroBloques+
      '\nHoras Bloques: '+  horarioClinicaUnico.numeroBloques"
         v-if="horarioClinicaUnico !== undefined && (idEspecialidadFiltro==null || horarioClinicaUnico.idEspecialidad === idEspecialidadFiltro)"
         @click.prevent="consultarDetalle(horarioClinicaUnico)"
         :style="horarioClinicaUnico.idBloque != null ? ancho+color2+tamanio2 + bloqueStyle + color2Bloque + '!important; background-size: 16px 48px !important;' : ancho+color2+tamanio2"
         @contextmenu.prevent="$refs.menu2.open"
    >
    </div>

    <vue-context ref="menu" v-if="activarDesactivarHorario(horarioClinica) || activarActivarHorario(horarioClinica)
      || activarBloquearHorario(horarioClinica)">
      <li v-if="activarActivarHorario(horarioClinica)">
        <a href="#" @click.prevent="activarHorario(horarioClinica)">Activar horario</a>
      </li>
      <li v-if="activarBloquearHorario(horarioClinica)">
        <a href="#" @click.prevent="bloquear(horarioClinica)">Bloquear horario</a>
      </li>
      <li v-if="activarDesactivarHorario(horarioClinica)">
        <a href="#" @click.prevent="desactivarHorario(horarioClinica)">Desactivar horario</a>
      </li>
      <li v-if="activarReasignarDoctor(horarioClinica)">
        <a href="#" @click.prevent="reasignarDoctor(horarioClinica)">Reasignar doctor</a>
      </li>
    </vue-context>

    <vue-context ref="menu2" v-if="activarDesactivarHorario(horarioClinicaUnico) || activarActivarHorario(horarioClinicaUnico)
      || activarBloquearHorario(horarioClinicaUnico)">
      <li v-if="activarDesactivarHorario(horarioClinicaUnico)">
        <a href="#" @click.prevent="desactivarHorario(horarioClinicaUnico)">Desactivar horario</a>
      </li>
      <li v-if="activarReasignarDoctor(horarioClinicaUnico)">
        <a href="#" @click.prevent="reasignarDoctor(horarioClinicaUnico)">Reasignar doctor</a>
      </li>
    </vue-context>

    <vue-context ref="menu1" v-if="activarDesbloquearHorario(horarioClinica1)">
      <li v-if="activarDesbloquearHorario(horarioClinica1)">
        <a href="#" @click.prevent="desbloquear(horarioClinica1)">Desbloquear horario</a>
      </li>
    </vue-context>

  </div>
</template>

<script>

export default {
  name: "HorarioSillonDoctores",
  props: {
    numeroSalas: {
      type: Number,
      default: -1,
    },
    horarioClinica: {
      type: Object,
    },
    horarioClinica1: {
      type: Object,
    },
    horarioClinicaUnico: {
      type: Object,
    },
    idEspecialidadFiltro : {
      type: Number
    }
  },
  computed: {
    ancho() {
      const num = this.numeroSalas - 4;

      if (this.numeroSalas <= 4) {
        return "width:20px;";
      } else if (this.numeroSalas <= 6) {
        return "width:"  + (20/num)+"px;";
      } else {
        return "width:"  + (20/num)+"px; color:black;";
      }

    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    colorBloque: "rgb(255, 102, 0)",
    color: "background:rgb(255, 102, 0);",
    tamanio: "height: 26.75px;",
    color1: "background:#FFFFFF;",
    color1Bloque: "#FFFFFF",
    tamanio1: "height: 26.75px;",
    color2: "background:#FFFFFF;",
    color2Bloque: "#FFF",
    tamanio2: "height: 26.75px;",
    bloqueStyle: " background: linear-gradient(180deg, #FFF 23%, transparent 23%) 7px 0, linear-gradient(0deg, transparent 74%, #FFF 78%), linear-gradient(180deg, transparent 34%, #FFF 38%, #FFF 58%, transparent 62%), ",
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.validarCita(this.horarioClinica);
    this.validarCitaUnica(this.horarioClinicaUnico);
    this.validarCitaBloqueado(this.horarioClinica1);
  },
  methods: {
    activarReasignarDoctor(horarioClinica) {
      if (horarioClinica !== undefined && !horarioClinica.horarioBloqueado) {
        return horarioClinica !== undefined && horarioClinica !== null && horarioClinica.registroActivo !== undefined && horarioClinica.registroActivo !== null
            && (horarioClinica.registroActivo) && this.$localStorageService.can('CD_cambio_dr');
      } else {
        return false;
      }
    },
    activarDesactivarHorario(horarioClinica) {
      if (horarioClinica !== undefined && !horarioClinica.horarioBloqueado) {
        return horarioClinica !== undefined && horarioClinica !== null && horarioClinica.registroActivo !== undefined && horarioClinica.registroActivo !== null
                && (horarioClinica.registroActivo) && this.$localStorageService.can('BO_17_desactivar');
      } else {
        return false;
      }
    },
    activarActivarHorario(horarioClinica) {
      if (horarioClinica !== undefined && !horarioClinica.horarioBloqueado) {
      return horarioClinica !== undefined && horarioClinica !== null && horarioClinica.registroActivo !== undefined && horarioClinica.registroActivo !== null
               && (!horarioClinica.registroActivo) && this.$localStorageService.can('BO_17_activar');
      } else {
        return false;
      }
    },
    activarBloquearHorario(horarioClinica) {
      if (horarioClinica !== undefined && !horarioClinica.horarioBloqueado) {
        return horarioClinica !== undefined && horarioClinica !== null && !horarioClinica.horarioBloqueado
                && (horarioClinica.registroActivo) && this.$localStorageService.can('BO_17_bloquear');
      } else {
        return false;
      }
    },
    activarDesbloquearHorario(horarioClinica) {
      if (horarioClinica !== undefined && horarioClinica.horarioBloqueado) {
        return horarioClinica !== undefined && horarioClinica !== null && horarioClinica.horarioBloqueado;// && this.$localStorageService.can('BO_17_desbloquear');
      } else {
        return false;
      }
    },
    desactivarHorario(horarioClinica) {
      const valor = {
        idAgendaEmpleado: horarioClinica.idAgendaEmpleado,
        registroActivo:false
      };
      this.$emit("activarDesactivarHorario", valor);
    },
    activarHorario(horarioClinica) {
      const valor = {
        idAgendaEmpleado: horarioClinica.idAgendaEmpleado,
        registroActivo:true
      };
      this.$emit("activarDesactivarHorario", valor);
    },
    bloquear(horarioClinica) {
      this.$emit("bloquear", JSON.parse(JSON.stringify(horarioClinica)));
    },
    desbloquear(horarioClinica) {
      this.$emit("desbloquear", JSON.parse(JSON.stringify(horarioClinica)));
    },
    consultarDetalle(horarioClinica) {
        this.$emit("consultarDetalle", horarioClinica);
    },
    reasignarDoctor(horarioClinica) {
      this.$emit("reasignarDoctor", JSON.parse(JSON.stringify(horarioClinica)));
    },
    validarCita(val) {
      if (val !== undefined) {
        this.color = "background:rgb(255, 102, 0);";
        this.colorBloque = "rgb(255, 102, 0) "
        this.tamanio = "height: 26.75px;";

        const fc1 = new Date("2014-02-27T" + val.horaInicioCasilla);
        const fc2 = new Date("2014-02-27T" + val.horaFinCasilla);
        const difMilisegundos = Math.abs(fc2 - fc1);
        const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
        let vecesRepetir = Math.abs(difMinutos / 15);

        if (vecesRepetir === 0) {
          vecesRepetir++;
        }
  
        const tamanio = 26.75 * vecesRepetir;
        // const tamanio = 26.75 * vecesRepetir - 53.5;

        this.color = val.color ? "background:" + val.color + " ;" : "background: #52D017;";
        this.colorBloque = val.color ? val.color : "#52D017 "
        this.tamanio = "height: " + tamanio + "px;";
      }
    },
    validarCitaUnica(val) {
      if (val !== undefined) {
        this.color1 = "background:rgb(255, 102, 0);";
        this.color1Bloque = "rgb(255, 102, 0)"
        this.tamanio1 = "height: 26.75px;";

        const fc1 = new Date("2014-02-27T" + val.horaInicioCasilla);
        const fc2 = new Date("2014-02-27T" + val.horaFinCasilla);
        const difMilisegundos = Math.abs(fc2 - fc1);
        const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
        let vecesRepetir = Math.abs(difMinutos / 15);

        if (vecesRepetir === 0) {
          vecesRepetir++;
        }
        const tamanio = 26.75 * vecesRepetir;
        // const tamanio = 26.75 * vecesRepetir - 53.5;

        this.color2 = val.color ? "background:" + val.color + " ;" : "background: #52D017;";
        this.color2Bloque = val.color ? val.color : "#52D017"
        this.tamanio2 = "height: " + tamanio + "px;";
      }
    },
    validarCitaBloqueado(val) {
      if (val !== undefined) {
        this.color1 = "background:#FFFFFF;"
        this.tamanio1 = "height: 26.75px;";

        const fc1 = new Date("2014-02-27T" + val.horaInicioCasilla);
        const fc2 = new Date("2014-02-27T" + val.horaFinCasilla);
        const difMilisegundos = Math.abs(fc2 - fc1);
        const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
        let vecesRepetir = Math.abs(difMinutos / 15);

        if (vecesRepetir === 0) {
          vecesRepetir++;
        }
        const tamanio = 26.75 * vecesRepetir;
        // const tamanio = 26.75 * vecesRepetir - 53.5;

        // this.color1 = "background:#FFFFFF;";
        this.tamanio1 = "height: " + tamanio + "px;";
      }
    }
  },
  watch: {
    horarioClinica() {
      this.validarCita(this.horarioClinica);
    },
    horarioClinicaUnico() {
      this.validarCitaUnica(this.horarioClinicaUnico);
    },
    horarioClinica1() {
      this.validarCitaBloqueado(this.horarioClinica1);
    }
  },
};
</script>


<style scoped>
  @import '~vue-context/dist/css/vue-context.css';

  .sala {
    /*min-width: 35px;*/
    height: 20px;
    font-size: small;
    font-weight: bolder;
  }

  .fa {
    font-size: 13px !important;
    margin-top: 10px !important;
  }

  .md-icon-button {
    width: 14px !important;
    min-width: 14px !important;
  ;
    height: 14px !important;
  ;
    margin: 0px !important;
  ;
    font-size: 11px !important;
  ;
  }

  .cita {
    position: absolute;
    padding: 2px;
    box-shadow: 2px 3px #b4afafad;
    margin-top: -4px;
    display: block;
    width: 20px;
    font-size: 0.4em;
    margin-left: 2px;
    z-index: 6;
    border-radius: 7px;
    border: solid 1px black;
    font-weight: bold;
    color: white;
  }

  .body-sala {
    position: absolute;
    width: 18px;
    left: 0px;
    top: 7px;
  }

  .bloqueado {
    background:
        linear-gradient(63deg, #FFF 23%, transparent 23%) 7px 0,
        linear-gradient(63deg, transparent 74%, #FFF 78%),
        linear-gradient(63deg, transparent 34%, #FFF 38%, #FFF 58%, transparent 62%),
        #444 !important;
    background-size: 16px 48px !important;
  }

  .bloque-especialista {
    background:
        linear-gradient(180deg, #FFF 23%, transparent 23%) 7px 0,
        linear-gradient(0deg, transparent 74%, #FFF 78%),
        linear-gradient(180deg, transparent 34%, #FFF 38%, #FFF 58%, transparent 62%),
        #007ea7 !important;
    background-size: 16px 48px !important;
  }
</style>